// extracted by mini-css-extract-plugin
export default {"bg":"styles_bg__b4nQU","ttl":"styles_ttl__t3MsQ","txt":"styles_txt__pwNNQ","btnSec1":"styles_btnSec1__4VaeT","btnSec2":"styles_btnSec2__hltln","img":"styles_img__b01i4"};